import { createContext, ReactNode, useContext } from "react";
import { createPortal } from "react-dom";

interface LayoutContextValue {
  headerActionsNode: HTMLElement | null;
}

const LayoutContext = createContext<LayoutContextValue>({
  headerActionsNode: null,
});

export const LayoutProvider = LayoutContext.Provider;

export const useLayout = () => useContext(LayoutContext);

/** Portals its children into the header-actions slot of the surrounding layout. */
export function PageHeaderActions({ children }: { children: ReactNode }) {
  const { headerActionsNode } = useLayout();
  return headerActionsNode ? createPortal(children, headerActionsNode) : null;
}
